module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/questions/3-038024b63428ea2f95142e7b586e47f8.svg";